import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  id: 0,
  call: {}
};

const getters = {
  attendence: data => {
    return data.call;
  },
  id: data => {
    return data.id;
  },
};

const actions = {
  save({ commit }, { attendence }) {
    try {
      commit('save', attendence );
      return true;
    } catch (e) {
      throw e;
    }
  },
};

const mutations = {
  save(state, attendence) {
    state.call = attendence;
  },
  id(state, id) {
    state.id = id;
  }
};



const pdv = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default pdv;

export { pdv };

